/**
 * This directory's own copy: `SlotMeter`'s label, `CapacityStats`' card labels, the organisation
 * page's own heading, and `RequestSlots`' dialog. No sentence about the product here — a card
 * carries a number and a label, never a clause explaining the billing model
 * (`[copy-explains-nothing-about-itself]`).
 *
 * `unit.vaga` is a plural noun, not a sentence: a request's amount renders through it.
 */

import { defineCatalogue } from '../../../i18n';

export const capacityCatalogue = defineCatalogue(
  {
    'meter.label': 'Vagas usadas',
    'stats.fraction': '{inUse} de {slots} em uso',
    'stats.over': 'Acima do limite',
    'stats.awaitingSlots': 'Aguardando slots',

    'page.title': 'Créditos e vagas',
    'badge.orgAdmin': 'Admin da organização',
    'slots.heading': 'Vagas de campanha',
    'slots.request': 'Pedir vagas',

    'card.credits.heading': 'Créditos',
    'card.credits.coverage': 'Cobre a coleta até {date} no ritmo atual.',
    'card.credits.stopped': 'Coleta parada desde {date}.',
    'card.credits.empty': 'Sem saldo',
    'card.accounts.heading': 'Contas cadastradas',

    'requests.heading': 'Pedidos em aberto',
    'requests.empty': 'Nenhum pedido em aberto',
    'requests.viewAll': 'Ver todos os pedidos',
    'requests.createdAt': 'Pedido em {date}',
    'requests.noAmount': 'Sem valor informado',
    'requests.all.title': 'Todos os pedidos',
    'requests.all.empty': 'Nenhum pedido ainda',

    'unit.vaga.other': '{n} vagas',
    'unit.vaga.one': '{n} vaga',

    'request.title': 'Pedir vagas de campanha',
    'request.current': 'Vagas hoje',
    'request.inUse': 'Em uso',
    'request.after': 'Com este pedido',
    'request.quantity.label': 'Quantas vagas a mais',
    'request.quantity.decrement': 'Uma vaga a menos',
    'request.quantity.increment': 'Uma vaga a mais',
    'request.context.label': 'Para quê (opcional)',
    'request.submit': 'Enviar pedido',
    'request.pending.title': 'Já existe um pedido de vagas em aberto',
    'request.pending.body': 'Aguarde a resposta antes de enviar outro pedido de vagas.',

    'consumption.heading': 'Consumo de créditos',
    'consumption.label': 'Consumo de créditos nos últimos 7 dias',
    'consumption.series': 'Créditos',
    'consumption.window': 'Últimos 7 dias',
    'consumption.average': 'Média diária',
    'consumption.maxDay': 'Maior dia',
    'consumption.maxDay.value': '{value} · {date}',
    'consumption.byCampaign.heading': 'Consumo por campanha',
    'consumption.byCampaign.empty': 'Nenhuma campanha com consumo nos últimos 7 dias',
  },
  {
    'meter.label': 'Slots used',
    'stats.fraction': '{inUse} of {slots} in use',
    'stats.over': 'Over the limit',
    'stats.awaitingSlots': 'Awaiting slots',

    'page.title': 'Credits and slots',
    'badge.orgAdmin': 'Organisation admin',
    'slots.heading': 'Campaign slots',
    'slots.request': 'Ask for slots',

    'card.credits.heading': 'Credits',
    'card.credits.coverage': 'Covers collection until {date} at the current pace.',
    'card.credits.stopped': 'Collection stopped on {date}.',
    'card.credits.empty': 'No balance',
    'card.accounts.heading': 'Accounts registered',

    'requests.heading': 'Open requests',
    'requests.empty': 'No open requests',
    'requests.viewAll': 'See every request',
    'requests.createdAt': 'Requested on {date}',
    'requests.noAmount': 'No amount given',
    'requests.all.title': 'Every request',
    'requests.all.empty': 'No requests yet',

    'unit.vaga.other': '{n} slots',
    'unit.vaga.one': '{n} slot',

    'request.title': 'Ask for campaign slots',
    'request.current': 'Slots today',
    'request.inUse': 'In use',
    'request.after': 'With this request',
    'request.quantity.label': 'How many more slots',
    'request.quantity.decrement': 'One fewer slot',
    'request.quantity.increment': 'One more slot',
    'request.context.label': 'What for (optional)',
    'request.submit': 'Send request',
    'request.pending.title': 'A slot request is already open',
    'request.pending.body': 'Wait for a reply before sending another slot request.',

    'consumption.heading': 'Credit consumption',
    'consumption.label': 'Credit consumption over the last 7 days',
    'consumption.series': 'Credits',
    'consumption.window': 'Last 7 days',
    'consumption.average': 'Daily average',
    'consumption.maxDay': 'Highest day',
    'consumption.maxDay.value': '{value} · {date}',
    'consumption.byCampaign.heading': 'Consumption by campaign',
    'consumption.byCampaign.empty': 'No campaign has spent anything in the last 7 days',
  },
);

export const cm = capacityCatalogue.t;
export const cmPlural = capacityCatalogue.plural;
